import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Alternative from './Alternative';


ReactDOM.render(
  <React.StrictMode>
    {/* <App /> */}
    <Alternative />
  </React.StrictMode>,
  document.getElementById('root')
);
